import React from 'react';
import Widget from './widget/index';
import Masonry from 'react-masonry-css';


const WidgetGrid = ({
    widgets,
    activeClientTab,
    selectedClient,
    widgetContents,
    handleWidgetContentChange,
    deleteWidget,
    selectedUseCase
}) => {
    const filteredWidgets = widgets.filter(widget => widget.tabId === activeClientTab);
    const breakpointColumnsObj = {
        default: 3,
        768: 2,
        500: 1
    };

    if (filteredWidgets.length === 0) {
        return (
            <div className="text-center py-8">
                <p className="text-gray-500">No widgets in this tab. Add a widget to get started.</p>
            </div>
        );
    }

    return (
        <Masonry
            breakpointCols={breakpointColumnsObj}
            className="flex w-auto gap-6 p-3 mb-6"
            columnClassName="bg-clip-padding"
        >
            {filteredWidgets.map(widget => (
                <div key={widget.key || widget.id} className="mb-6">
                    <Widget
                        id={widget.id}
                        title={widget.title}
                        subtitle={widget.subtitle}
                        prompt={widget.prompt}
                        chartPrompt={widget.chartPrompt ? widget.chartPrompt : null}
                        customerId={selectedClient?.id || widget.customerId}
                        tool={widget.tool}
                        endpoint={widget.endpoint}
                        content={widget.content}
                        status={widget.status}
                        hasAvatar={widget.hasAvatar}
                        onContentChange={handleWidgetContentChange}
                        onDelete={async (id) => {
                            await deleteWidget(id);
                        }}
                        useCaseId={selectedUseCase}
                    />
                </div>
            ))}
        </Masonry>
    );
};

export default WidgetGrid;